import React, {useState} from "react";
import PaymentsList from "./PaymentsList";
import PaymentEditor from "./PaymentEditor";
import Notification from "../Common/Notification";

const PaymentsSettings = () => {
    const [notification, setNotification] = useState({
        show: false,
        type: "success",
        message: "",
    });
    const [isEditorOpen, setIsEditorOpen] = useState(false);
    const [currentPayment, setCurrentPayment] = useState(null);
    const [selectedPayments, setSelectedPayments] = useState([]);
    const [selectedAll, setSelectedAll] = useState(false);

    const showNotification = (type, message) => {
        setNotification({show: true, type, message});
        if (type === "success") {
            setTimeout(() => {
                setNotification((prev) => ({...prev, show: false}));
            }, 5000);
        }
    };

    const hideNotification = () => {
        setNotification((prev) => ({...prev, show: false}));
    };

    const handleAddPayment = () => {
        setCurrentPayment(null);
        setIsEditorOpen(true);
    };

    const handleEditPayment = (payment) => {
        setCurrentPayment(payment);
        setIsEditorOpen(true);
    };

    const handleCloseEditor = () => {
        setIsEditorOpen(false);
        setCurrentPayment(null);
    };

    const handleDeleteSelected = (paymentIds) => {
        // This function is just a pass-through to the PaymentsList component
        // The actual deletion logic is in PaymentsList
    };

    return (
        <div>
            <PaymentsList
                showNotification={showNotification}
                onEditPayment={handleEditPayment}
                onAddPayment={handleAddPayment}
                onDeleteSelected={handleDeleteSelected}
                selectedItems={selectedPayments}
                setSelectedItems={setSelectedPayments}
                selectedAll={selectedAll}
                setSelectedAll={setSelectedAll}
            />

            {isEditorOpen && (
                <PaymentEditor
                    payment={currentPayment}
                    onClose={handleCloseEditor}
                    showNotification={showNotification}
                />
            )}

            {notification.show && (
                <Notification
                    type={notification.type}
                    message={notification.message}
                    onClose={hideNotification}
                />
            )}
        </div>
    );
};

export default PaymentsSettings;
